<div *ngIf="!isLoading; else preloader" class="p500-ui-modal__inner">
  <div class="p500-ui-modal__body -metrics">
    <div class="p500-ui-modal__close" (click)="closeModal(); $event.preventDefault()">
      <p500-ui-icon name="close" size="20px"></p500-ui-icon>
    </div>
    <ng-container *ngIf="data.metric.metric_type === metricTypes.BASE">
      <gtd-base-metric-card [row]="metricData" [viewOnly]="true"></gtd-base-metric-card>
    </ng-container>
    <ng-container *ngIf="data.metric.metric_type === metricTypes.NETWORK">
      <gtd-network-metric-card [row]="metricData" [viewOnly]="true"></gtd-network-metric-card>
    </ng-container>
  </div>
</div>

<ng-template #preloader>
  <p500-ui-cube-preloader></p500-ui-cube-preloader>
</ng-template>
